
import * as dom from './wpstg-dom-utils.js';
import WpstgDirectoryNavigation from './wpstg-directory-navigation.js';
import WpstgExcludeFilters from './wpstg-exclude-filters.js';
import WpstgModal from './wpstg-modal.js';
import WPStagingCommon from './../wpstg.js';

/**
 * Manage RESET MODAL
 */
export default class WpstgResetModal {
  constructor(
      cloneID,
      workflowSelector = '#wpstg-workflow',
      fetchExcludeSettingsAction = 'wpstg_clone_excludes_settings',
      modalErrorAction = 'wpstg_modal_error',
      wpstgObject = wpstg,
  ) {
    this.cloneID = cloneID;
    this.workflow = dom.qs(workflowSelector);
    this.wpstgObject = wpstgObject;
    this.fetchExcludeSettingsAction = fetchExcludeSettingsAction;
    this.modalErrorAction = modalErrorAction;
    this.resetButtonClass = 'wpstg-confirm-reset-clone';
    this.resetModalContainerClass = 'wpstg-reset-confirmation';
    this.resetTabSelector = '.wpstg-reset-exclude-tab';
    this.directoryNavigator = null;
    this.excludeFilters = null;
    this.isAllTablesChecked = true;
  }

  addEvents() {
    const resetModalContainer = dom.qs('.' + this.resetModalContainerClass);
    if (resetModalContainer === null) {
      console.log('Exit');
      return;
    }

    dom.addEvent(resetModalContainer, 'click', this.resetTabSelector, (target) => {
      this.toggleContent(target);
    });

    dom.addEvent(resetModalContainer, 'click', '.wpstg-button-select', () => {
      this.selectDefaultTables();
    });

    dom.addEvent(resetModalContainer, 'click', '.wpstg-button-unselect', () => {
      this.toggleTableSelection();
    });

    dom.addEvent(resetModalContainer, 'click', '.wpstg-expand-dirs', (target, event) => {
      event.preventDefault();
      this.toggleDirectoryNavigation(target);
    });

    dom.addEvent(resetModalContainer, 'change', 'input.wpstg-check-dir', (target) => {
      this.updateDirectorySelection(target);
    });
  }

  init() {
    this.addEvents();
  }

  toggleContent(target) {
    const resetModalContainer = dom.qs('.' + this.resetModalContainerClass);
    const contentId = target.getAttribute('data-id');
    const tabTriangle = target.querySelector('.wpstg-tab-triangle');
    const isCollapsed = target.getAttribute('data-collapsed', 'true');
    const content = dom.qs(contentId);
    if (isCollapsed === 'true') {
      if (resetModalContainer.classList.contains('has-collapsible-open')) {
        resetModalContainer.classList.add('has-collapsible-open-2');
      } else {
        resetModalContainer.classList.add('has-collapsible-open');
      }

      dom.slideDown(content);
      tabTriangle.style.transform = 'rotate(90deg)';
      target.setAttribute('data-collapsed', 'false');
    } else {
      if (resetModalContainer.classList.contains('has-collapsible-open-2')) {
        resetModalContainer.classList.remove('has-collapsible-open-2');
      } else {
        resetModalContainer.classList.remove('has-collapsible-open');
      }

      dom.slideUp(content);
      tabTriangle.style.removeProperty('transform');
      target.setAttribute('data-collapsed', 'true');
    }
  }

  /**
   * Show Swal alert with loader and send ajax request to fetch content of alert.
   * @return Promise
   */
  showModal() {
    const swalPromise = this.loadModal();
    this.init();
    this.fetchCloneExcludes();
    return swalPromise;
  }

  loadModal() {
    return WPStagingCommon.getSwalModal(false, {
      confirmButton: this.resetButtonClass + ' wpstg-confirm-reset-clone wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn',
      container: this.resetModalContainerClass + ' wpstg-swal2-container wpstg-swal2-loading',
    }).fire({
      title: '',
      icon: 'warning',
      html: this.getAjaxLoader(),
      width: '400px',
      focusConfirm: false,
      confirmButtonText: this.wpstgObject.i18n.resetClone,
      showCancelButton: true,
    });
  }

  fetchCloneExcludes() {
    this.error = null;
    // send ajax request and fetch preserved exclude settings
    fetch(this.wpstgObject.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams({
        action: this.fetchExcludeSettingsAction,
        accessToken: this.wpstgObject.accessToken,
        nonce: this.wpstgObject.nonce,
        clone: this.cloneID,
        job: 'resetting',
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }

      return Promise.reject(response);
    }).then((data) => {
      if (!data.success) {
        const errorModal = new WpstgModal(this.modalErrorAction, this.wpstgObject);
        errorModal.show(Object.assign({
          title: 'Error',
          icon: 'error',
          html: this.wpstgObject.i18n['somethingWentWrong'],
          width: '500px',
          confirmButtonText: 'Ok',
          showCancelButton: false,
          customClass: {
            confirmButton: 'wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn',
            cancelButton: 'wpstg--btn--cancel wpstg-blue-primary wpstg-link-btn',
            actions: 'wpstg--modal--actions',
            popup: 'wpstg-swal-popup centered-modal',
          },
          buttonsStyling: false,
          reverseButtons: true,
        }, data.swalOptions), {
          type: data.type,
        });

        return;
      }

      const modal = dom.qs('.wpstg-reset-confirmation');
      modal.classList.remove('wpstg-swal2-loading');
      modal.querySelector('.wpstg--swal2-popup').style.width = '500px';
      modal.querySelector('.wpstg--swal2-content').innerHTML = data.html;
      this.directoryNavigator = new WpstgDirectoryNavigation();
      this.excludeFilters = new WpstgExcludeFilters();
    }).catch((error) => {
      this.renderError({
        'html': this.wpstgObject.i18n['somethingWentWrong'] + ' ' + error,
      });
    });
  }

  getDirectoryNavigator() {
    return this.directoryNavigator;
  }

  getExcludeFilters() {
    return this.excludeFilters;
  }

  getAjaxLoader() {
    return '<div class="wpstg-swal2-ajax-loader"><img src="' + this.wpstgObject.wpstgIcon + '" /></div>';
  }

  toggleDirectoryNavigation(element) {
    const cbElement = element.previousSibling;
    if (cbElement.getAttribute('data-navigateable', 'false') === 'false') {
      return;
    }

    if (cbElement.getAttribute('data-scanned', 'false') === 'false') {
      return;
    }

    const subDirectories = dom.getNextSibling(element, '.wpstg-subdir');

    if (subDirectories.style.display === 'none') {
      dom.slideDown(subDirectories);
    } else {
      dom.slideUp(subDirectories);
    }
  }

  updateDirectorySelection(element) {
    const parent = element.parentElement;
    if (element.checked) {
      dom.getParents(parent, '.wpstg-dir').forEach((parElem) => {
        for (let i = 0; i < parElem.children.length; i++) {
          if (parElem.children[i].matches('.wpstg-check-dir')) {
            parElem.children[i].checked = true;
          }
        }
      });
      parent.querySelectorAll('.wpstg-expand-dirs').forEach((x) => {
        x.classList.remove('disabled');
      });
      parent.querySelectorAll('.wpstg-subdir .wpstg-check-dir').forEach((x) => {
        x.checked = true;
      });
    } else {
      parent.querySelectorAll('.wpstg-expand-dirs, .wpstg-check-subdirs').forEach((x) => {
        x.classList.add('disabled');
      });
      parent.querySelectorAll('.wpstg-dir .wpstg-check-dir').forEach((x) => {
        x.checked = false;
      });
    }
  }

  selectDefaultTables() {
    const resetModalContainer = dom.qs('.' + this.resetModalContainerClass);
    const options = resetModalContainer.querySelectorAll('#wpstg_select_tables_cloning .wpstg-db-table');
    const multisitePattern = '^' + this.wpstgObject.tblprefix + '([^0-9])_*';
    const singleSitePattern = '^' + this.wpstgObject.tblprefix;
    options.forEach((option) => {
      const name = option.getAttribute('name', '');
      if (this.wpstgObject.isMultisite === '1' && name.match(multisitePattern)) {
        option.setAttribute('selected', 'selected');
      } else if (this.wpstgObject.isMultisite === '' && name.match(singleSitePattern)) {
        option.setAttribute('selected', 'selected');
      } else {
        option.removeAttribute('selected');
      }
    });
  }

  toggleTableSelection() {
    const resetModalContainer = dom.qs('.' + this.resetModalContainerClass);
    if (false === this.isAllTablesChecked) {
      resetModalContainer.querySelectorAll('#wpstg_select_tables_cloning .wpstg-db-table').forEach((option) => {
        option.setAttribute('selected', 'selected');
      });
      resetModalContainer.querySelector('.wpstg-button-unselect').innerHTML = 'Unselect All';
      // cache.get('.wpstg-db-table-checkboxes').prop('checked', true);
      this.isAllTablesChecked = true;
    } else {
      resetModalContainer.querySelectorAll('#wpstg_select_tables_cloning .wpstg-db-table').forEach((option) => {
        option.removeAttribute('selected');
      });
      resetModalContainer.querySelector('.wpstg-button-unselect').innerHTML = 'Select All';
      // cache.get('.wpstg-db-table-checkboxes').prop('checked', false);
      this.isAllTablesChecked = false;
    }
  }
}
